import React from 'react';
import { AttachMediaModal } from '../../../../components/AttachMediaModal';
import { ElementWrapper } from '../../../../components/ElementWrapper';
import { IElement } from '../../../../models/Element';
import { HomeRightDescriptionFloatingWindowContent } from './HomeRightDescriptionFloatingWindowContent';
import { HomeRightDescriptionWithFloatingWindowElement } from './HomeRightDescriptionFloatingWindowElement';
import { HomeRightDescriptionFloatingWindowFigure } from './HomeRightDescriptionFloatingWindowFigure';

interface Props {
  index: number;
  data: HomeRightDescriptionWithFloatingWindowElement;
  updateData: (element: IElement, index: number) => void;
}

export const HomeRightDescriptionFloatingWindowFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (
    fieldsToUpdate: Partial<HomeRightDescriptionWithFloatingWindowElement>
  ) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <AttachMediaModal
        modalId={`${data.name}-${data.id}`}
        updateCallback={(image, image_alt) =>
          update({ image_preview: image, image_preview_alt: image_alt })
        }
      />

      <ElementWrapper elementIndex={index}>
        <div className="home-image-floating-right-description">
          <div className="showcase">
            <HomeRightDescriptionFloatingWindowContent
              data={data}
              update={update}
            />
            <HomeRightDescriptionFloatingWindowFigure
              data={data}
              update={update}
            />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
